<template>
  <PageTemplate :isLoggedIn="false" enclosingCssId="paypoint-login-page">
    <template v-slot:page-content>
      <b-container fluid id="page-container">
        <LoginFormDynamic />
      </b-container>
    </template>
  </PageTemplate>
</template>

<script>
import PageTemplate from "Components/PageTemplate";
import LoginFormDynamic from "Components/LoginFormDynamic";

export default {
  name: "LoginPage",
  components: {
    PageTemplate,
    LoginFormDynamic,
  },
};
</script>

<style lang="scss" scoped>
@import "Design/_variables.scss";
@import "Design/paypoint-form-common-styles.scss";
</style>
